import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BookingModal from '../../components/feature/BookingModal';
import { SEO } from '../../utils/seo';

export default function FullsizeCarPage() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState<any>(null);
  const [galleryType, setGalleryType] = useState<'exterior' | 'interior'>('exterior');
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const vehicles = [
    {
      id: 1,
      name: '제네시스 G80',
      price: '250,000',
      fuel: '가솔린(24년식)',
      seats: '5인승',
      transmission: '자동',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/318d6752c1b89745aaebcac4f7d86953.png',
      exteriorImages: [
        'https://public.readdy.ai/ai/img_res/47cd01796d65badc60b02f1eace3411f.jpg',
        'https://readdy.ai/api/search-image?query=Genesis%20G80%20luxury%20sedan%20exterior%20side%20profile%20view%20in%20elegant%20silver%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20long%20wheelbase%20and%20elegant%20proportions&width=1200&height=800&seq=fullsize-g80-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Genesis%20G80%20luxury%20sedan%20exterior%20rear%20three-quarter%20view%20in%20elegant%20silver%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20distinctive%20two-line%20LED%20lamps%20and%20refined%20rear%20styling&width=1200&height=800&seq=fullsize-g80-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Genesis%20G80%20sedan%20interior%20dashboard%20and%20front%20seats%20view%20with%20luxurious%20black%20Nappa%20leather%20upholstery%2C%20dual%20widescreen%20displays%2C%20premium%20wood%20trim%2C%20ambient%20lighting%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=fullsize-g80-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Genesis%20G80%20sedan%20interior%20center%20console%20close-up%20view%20with%20premium%20materials%2C%20crystal%20sphere%20gear%20selector%2C%20Genesis%20luxury%20details%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=fullsize-g80-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Genesis%20G80%20sedan%20interior%20rear%20passenger%20seats%20view%20with%20spacious%20black%20Nappa%20leather%20seating%2C%20premium%20relaxation%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20first-class%20luxury%20and%20comfort&width=1200&height=800&seq=fullsize-g80-int-3&orientation=landscape',
      ],
    },
    {
      id: 2,
      name: '제네시스 G90',
      price: '350,000',
      fuel: '가솔린(24년식)',
      seats: '5인승',
      transmission: '자동',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/23c50bb584b76ee71b5a1ba70f6b9a03.png',
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Genesis%20G90%20flagship%20luxury%20sedan%20exterior%20front%20three-quarter%20view%20in%20prestigious%20black%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20highlighting%20ultimate%20Korean%20luxury%20and%20executive%20presence&width=1200&height=800&seq=fullsize-g90-ext-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Genesis%20G90%20flagship%20luxury%20sedan%20exterior%20side%20profile%20view%20in%20prestigious%20black%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20majestic%20proportions%20and%20commanding%20presence&width=1200&height=800&seq=fullsize-g90-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Genesis%20G90%20flagship%20luxury%20sedan%20exterior%20rear%20three-quarter%20view%20in%20prestigious%20black%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20distinctive%20Genesis%20design%20and%20luxury%20character&width=1200&height=800&seq=fullsize-g90-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Genesis%20G90%20sedan%20interior%20dashboard%20and%20front%20seats%20view%20with%20ultra-luxurious%20beige%20Nappa%20leather%20upholstery%2C%20dual%20curved%20displays%2C%20premium%20wood%20and%20metal%20trim%2C%20ambient%20lighting%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=fullsize-g90-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Genesis%20G90%20sedan%20interior%20center%20console%20close-up%20view%20with%20ultra-premium%20materials%2C%20crystal%20sphere%20gear%20selector%2C%20intricate%20Genesis%20luxury%20details%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=fullsize-g90-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Genesis%20G90%20sedan%20interior%20rear%20passenger%20seats%20view%20with%20ultra-spacious%20beige%20Nappa%20leather%20seating%2C%20executive%20relaxation%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20ultimate%20first-class%20luxury%20experience&width=1200&height=800&seq=fullsize-g90-int-3&orientation=landscape',
      ],
    },
    {
      id: 3,
      name: 'BMW 5시리즈',
      price: '250,000',
      fuel: '디젤',
      seats: '5인승',
      transmission: '자동',
      image: 'https://readdy.ai/api/search-image?query=BMW%205%20Series%20luxury%20sedan%20in%20sophisticated%20gray%20color%20on%20clean%20minimalist%20gradient%20background%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20professional%20automotive%20photography%20with%20studio%20lighting%2C%20German%20premium%20executive%20sedan%2C%20side%20three-quarter%20view%20emphasizing%20dynamic%20elegance%20and%20sporty%20luxury&width=500&height=350&seq=fullsize-bmw5-001&orientation=landscape',
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=BMW%205%20Series%20luxury%20sedan%20exterior%20front%20three-quarter%20view%20in%20sophisticated%20gray%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20highlighting%20iconic%20kidney%20grille%20and%20athletic%20design&width=1200&height=800&seq=fullsize-bmw5-ext-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=BMW%205%20Series%20luxury%20sedan%20exterior%20side%20profile%20view%20in%20sophisticated%20gray%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20dynamic%20proportions%20and%20sporty%20elegance&width=1200&height=800&seq=fullsize-bmw5-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=BMW%205%20Series%20luxury%20sedan%20exterior%20rear%20three-quarter%20view%20in%20sophisticated%20gray%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20distinctive%20LED%20tail%20lights%20and%20refined%20rear%20design&width=1200&height=800&seq=fullsize-bmw5-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=BMW%205%20Series%20sedan%20interior%20dashboard%20and%20front%20seats%20view%20with%20premium%20black%20leather%20sport%20seats%2C%20curved%20display%20screen%2C%20modern%20digital%20cockpit%2C%20German%20luxury%20materials%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=fullsize-bmw5-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=BMW%205%20Series%20sedan%20interior%20center%20console%20close-up%20view%20with%20premium%20materials%2C%20electronic%20gear%20selector%2C%20iDrive%20controller%2C%20BMW%20luxury%20details%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=fullsize-bmw5-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=BMW%205%20Series%20sedan%20interior%20rear%20passenger%20seats%20view%20with%20spacious%20black%20leather%20seating%2C%20premium%20comfort%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20German%20luxury%20and%20comfort&width=1200&height=800&seq=fullsize-bmw5-int-3&orientation=landscape',
      ],
    },
    {
      id: 4,
      name: '벤츠 E클래스',
      price: '250,000',
      fuel: '디젤',
      seats: '5인승',
      transmission: '자동',
      image: 'https://readdy.ai/api/search-image?query=Mercedes-Benz%20E-Class%20luxury%20sedan%20in%20elegant%20silver%20color%20on%20clean%20minimalist%20gradient%20background%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20professional%20automotive%20photography%20with%20studio%20lighting%2C%20German%20luxury%20executive%20sedan%2C%20side%20three-quarter%20view%20highlighting%20refined%20design%20and%20prestigious%20character&width=500&height=350&seq=fullsize-eclass-001&orientation=landscape',
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Mercedes-Benz%20E-Class%20luxury%20sedan%20exterior%20front%20three-quarter%20view%20in%20elegant%20silver%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20highlighting%20iconic%20Mercedes%20star%20grille%20and%20sophisticated%20design&width=1200&height=800&seq=fullsize-eclass-ext-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Mercedes-Benz%20E-Class%20luxury%20sedan%20exterior%20side%20profile%20view%20in%20elegant%20silver%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20elegant%20proportions%20and%20timeless%20styling&width=1200&height=800&seq=fullsize-eclass-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Mercedes-Benz%20E-Class%20luxury%20sedan%20exterior%20rear%20three-quarter%20view%20in%20elegant%20silver%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20distinctive%20LED%20tail%20lights%20and%20refined%20rear%20design&width=1200&height=800&seq=fullsize-eclass-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Mercedes-Benz%20E-Class%20sedan%20interior%20dashboard%20and%20front%20seats%20view%20with%20luxurious%20black%20leather%20seats%2C%20dual%20widescreen%20MBUX%20display%2C%20premium%20wood%20trim%2C%20German%20luxury%20materials%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=fullsize-eclass-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Mercedes-Benz%20E-Class%20sedan%20interior%20center%20console%20close-up%20view%20with%20premium%20materials%2C%20electronic%20gear%20selector%2C%20Mercedes%20luxury%20details%2C%20ambient%20lighting%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=fullsize-eclass-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Mercedes-Benz%20E-Class%20sedan%20interior%20rear%20passenger%20seats%20view%20with%20spacious%20black%20leather%20seating%2C%20premium%20comfort%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20Mercedes%20luxury%20and%20refinement&width=1200&height=800&seq=fullsize-eclass-int-3&orientation=landscape',
      ],
    },
    {
      id: 5,
      name: '아우디 A6',
      price: '250,000',
      fuel: '디젤',
      seats: '5인승',
      transmission: '자동',
      image: 'https://readdy.ai/api/search-image?query=Audi%20A6%20luxury%20sedan%20in%20sophisticated%20dark%20blue%20color%20on%20clean%20minimalist%20gradient%20background%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20professional%20automotive%20photography%20with%20studio%20lighting%2C%20German%20premium%20executive%20sedan%2C%20side%20three-quarter%20view%20emphasizing%20progressive%20design%20and%20technological%20elegance&width=500&height=350&seq=fullsize-a6-001&orientation=landscape',
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Audi%20A6%20luxury%20sedan%20exterior%20front%20three-quarter%20view%20in%20sophisticated%20dark%20blue%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20highlighting%20Singleframe%20grille%20and%20progressive%20design&width=1200&height=800&seq=fullsize-a6-ext-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Audi%20A6%20luxury%20sedan%20exterior%20side%20profile%20view%20in%20sophisticated%20dark%20blue%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20sleek%20proportions%20and%20technological%20elegance&width=1200&height=800&seq=fullsize-a6-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Audi%20A6%20luxury%20sedan%20exterior%20rear%20three-quarter%20view%20in%20sophisticated%20dark%20blue%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20distinctive%20LED%20tail%20lights%20and%20modern%20rear%20design&width=1200&height=800&seq=fullsize-a6-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Audi%20A6%20sedan%20interior%20dashboard%20and%20front%20seats%20view%20with%20premium%20black%20leather%20seats%2C%20dual%20touchscreen%20MMI%20displays%2C%20modern%20digital%20cockpit%2C%20German%20luxury%20materials%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=fullsize-a6-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Audi%20A6%20sedan%20interior%20center%20console%20close-up%20view%20with%20premium%20materials%2C%20electronic%20gear%20selector%2C%20MMI%20touch%20response%2C%20Audi%20luxury%20details%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=fullsize-a6-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Audi%20A6%20sedan%20interior%20rear%20passenger%20seats%20view%20with%20spacious%20black%20leather%20seating%2C%20premium%20comfort%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20Audi%20luxury%20and%20technology&width=1200&height=800&seq=fullsize-a6-int-3&orientation=landscape',
      ],
    },
    {
      id: 6,
      name: '렉서스 ES',
      price: '250,000',
      fuel: '하이브리드',
      seats: '5인승',
      transmission: '자동',
      image: 'https://readdy.ai/api/search-image?query=Lexus%20ES%20luxury%20sedan%20in%20premium%20white%20color%20on%20clean%20minimalist%20gradient%20background%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20professional%20automotive%20photography%20with%20studio%20lighting%2C%20Japanese%20luxury%20sedan%20with%20refined%20design%2C%20side%20three-quarter%20view%20highlighting%20elegant%20styling%20and%20sophisticated%20presence&width=500&height=350&seq=fullsize-es-001&orientation=landscape',
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Lexus%20ES%20luxury%20sedan%20exterior%20front%20three-quarter%20view%20in%20premium%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20highlighting%20spindle%20grille%20and%20refined%20Japanese%20luxury%20design&width=1200&height=800&seq=fullsize-es-ext-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Lexus%20ES%20luxury%20sedan%20exterior%20side%20profile%20view%20in%20premium%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20elegant%20proportions%20and%20sophisticated%20styling&width=1200&height=800&seq=fullsize-es-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Lexus%20ES%20luxury%20sedan%20exterior%20rear%20three-quarter%20view%20in%20premium%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20distinctive%20LED%20tail%20lights%20and%20refined%20rear%20design&width=1200&height=800&seq=fullsize-es-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Lexus%20ES%20sedan%20interior%20dashboard%20and%20front%20seats%20view%20with%20luxurious%20beige%20leather%20seats%2C%20large%20touchscreen%20display%2C%20digital%20instrument%20cluster%2C%20Japanese%20craftsmanship%20materials%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=fullsize-es-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Lexus%20ES%20sedan%20interior%20center%20console%20close-up%20view%20with%20premium%20materials%2C%20electronic%20gear%20selector%2C%20Lexus%20luxury%20details%2C%20ambient%20lighting%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=fullsize-es-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Lexus%20ES%20sedan%20interior%20rear%20passenger%20seats%20view%20with%20spacious%20beige%20leather%20seating%2C%20premium%20comfort%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20Japanese%20luxury%20craftsmanship%20and%20comfort&width=1200&height=800&seq=fullsize-es-int-3&orientation=landscape',
      ],
    },
  ];

  const openGallery = (vehicle: any, type: 'exterior' | 'interior') => {
    setSelectedVehicle(vehicle);
    setGalleryType(type);
    setCurrentImageIndex(0);
    setIsGalleryOpen(true);
  };

  const closeGallery = () => {
    setIsGalleryOpen(false);
    setSelectedVehicle(null);
  };

  const getCurrentImages = () => {
    if (!selectedVehicle) return [];
    return galleryType === 'exterior' ? selectedVehicle.exteriorImages : selectedVehicle.interiorImages;
  };

  const nextImage = () => {
    const images = getCurrentImages();
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    const images = getCurrentImages();
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "CollectionPage",
        "name": "대전대형차렌트카",
        "description": "프리미엄 대형차로 품격 있는 이동을 경험하세요. 비즈니스 미팅, 중요한 행사, 장거리 여행에 최적화된 럭셔리 차량입니다.",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/fullsize-car`,
        "isPartOf": {
          "@type": "WebSite",
          "name": "대전렌트카",
          "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
        }
      },
      {
        "@type": "ItemList",
        "name": "대전 대형차 렌트 차량 목록",
        "description": "대전렌트카 프리미엄 대형차 렌트 차량 목록",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/fullsize-car`,
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "제네시스 G80",
            "description": "가솔린 24년식 프리미엄 대형 세단, 1일 렌트 ₩250,000"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "제네시스 G90",
            "description": "가솔린 24년식 플래그십 대형 세단, 1일 렌트 ₩350,000"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "BMW 5시리즈",
            "description": "디젤 독일 프리미엄 대형 세단, 1일 렌트 ₩250,000"
          },
          {
            "@type": "ListItem",
            "position": 4,
            "name": "벤츠 E클래스",
            "description": "디젤 독일 럭셔리 대형 세단, 1일 렌트 ₩250,000"
          },
          {
            "@type": "ListItem",
            "position": 5,
            "name": "아우디 A6",
            "description": "디젤 독일 프리미엄 대형 세단, 1일 렌트 ₩250,000"
          },
          {
            "@type": "ListItem",
            "position": 6,
            "name": "렉서스 ES",
            "description": "하이브리드 일본 럭셔리 대형 세단, 1일 렌트 ₩250,000"
          }
        ]
      }
    ]
  };

  return (
    <>
      <div className="min-h-screen bg-white">
        <SEO
          title="대전대형차렌트카 - 프리미엄 대형차 렌트 | 대전렌트카"
          description="프리미엄 대형차로 품격 있는 이동을 경험하세요. 비즈니스 미팅, 중요한 행사, 장거리 여행에 최적화된 럭셔리 차량입니다. 24시간 예약 가능."
          keywords="대전대형차렌트카, 대전대형차대여, 프리미엄렌트카, 럭셔리렌트카, 비즈니스렌트카"
          canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/fullsize-car`}
          schema={schema}
        />
        <Navbar />
        <main className="pt-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <div className="mb-12">
              <div className="flex items-center justify-between mb-4">
                <h1 className="text-5xl font-bold text-gray-900">대전대형차렌트카</h1>
                <a 
                  href="tel:010-5437-1535"
                  className="flex items-center gap-3 bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary/90 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-phone-line text-xl"></i>
                  <span className="font-semibold">010-5437-1535</span>
                </a>
              </div>
              <p className="text-lg text-gray-600">
                프리미엄 대형차로 품격 있는 이동을 경험하세요. 
                비즈니스 미팅, 중요한 행사, 장거리 여행에 최적화된 럭셔리 차량입니다.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {vehicles.map((vehicle) => (
                <div key={vehicle.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                  <div className="h-64 bg-gradient-to-b from-sky-50 to-white p-6">
                    <img
                      src={vehicle.image}
                      alt={vehicle.name}
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">{vehicle.name}</h3>
                    <p className="text-3xl font-extrabold text-primary mb-1">₩{vehicle.price}</p>
                    <p className="text-sm text-gray-500 mb-4">자차별도</p>
                    <div className="grid grid-cols-2 gap-3 mb-6 text-sm text-gray-600">
                      <div className="flex items-center gap-2">
                        <i className="ri-gas-station-line text-primary"></i>
                        <span>{vehicle.fuel}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <i className="ri-user-line text-primary"></i>
                        <span>{vehicle.seats}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <i className="ri-settings-3-line text-primary"></i>
                        <span>{vehicle.transmission}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <i className="ri-calendar-line text-primary"></i>
                        <span>1일 기준</span>
                      </div>
                    </div>

                    {/* 이미지 갤러리 버튼 */}
                    <div className="flex gap-2 mb-4">
                      <button
                        onClick={() => openGallery(vehicle, 'exterior')}
                        className="flex-1 px-3 py-2 bg-gray-100 text-gray-700 text-xs md:text-sm font-medium rounded-lg hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <i className="ri-image-line mr-1"></i>
                        외부사진
                      </button>
                      <button
                        onClick={() => openGallery(vehicle, 'interior')}
                        className="flex-1 px-3 py-2 bg-gray-100 text-gray-700 text-xs md:text-sm font-medium rounded-lg hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <i className="ri-steering-2-line mr-1"></i>
                        내부사진
                      </button>
                    </div>

                    <a 
                      href="tel:010-5437-1535"
                      className="w-full bg-gray-900 text-white py-3 rounded-xl font-medium hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap block text-center"
                    >
                      지금 예약하기
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </main>
        <Footer />
        <BookingModal 
          isOpen={isBookingModalOpen} 
          onClose={() => setIsBookingModalOpen(false)} 
        />

        {/* 이미지 갤러리 모달 */}
        {isGalleryOpen && selectedVehicle && (
          <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4">
            <button
              onClick={closeGallery}
              className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-4xl"></i>
            </button>

            <div className="w-full max-w-6xl">
              {/* 탭 */}
              <div className="flex justify-center gap-4 mb-6">
                <button
                  onClick={() => { setGalleryType('exterior'); setCurrentImageIndex(0); }}
                  className={`px-6 py-2 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    galleryType === 'exterior'
                      ? 'bg-primary text-white'
                      : 'bg-white/20 text-white hover:bg-white/30'
                  }`}
                >
                  외부사진
                </button>
                <button
                  onClick={() => { setGalleryType('interior'); setCurrentImageIndex(0); }}
                  className={`px-6 py-2 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    galleryType === 'interior'
                      ? 'bg-primary text-white'
                      : 'bg-white/20 text-white hover:bg-white/30'
                  }`}
                >
                  내부사진
                </button>
              </div>

              {/* 메인 이미지 */}
              <div className="relative aspect-video bg-black rounded-lg overflow-hidden mb-4">
                <img
                  src={getCurrentImages()[currentImageIndex]}
                  alt={`${selectedVehicle.name} ${galleryType === 'exterior' ? '외부' : '내부'} ${currentImageIndex + 1}`}
                  className="w-full h-full object-contain"
                />
                
                <button
                  onClick={prevImage}
                  className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-left-s-line text-2xl"></i>
                </button>
                <button
                  onClick={nextImage}
                  className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-s-line text-2xl"></i>
                </button>
              </div>

              {/* 썸네일 */}
              <div className="flex justify-center gap-2">
                {getCurrentImages().map((img, idx) => (
                  <button
                    key={idx}
                    onClick={() => setCurrentImageIndex(idx)}
                    className={`w-20 h-20 rounded-lg overflow-hidden border-2 transition-all cursor-pointer ${
                      idx === currentImageIndex ? 'border-primary' : 'border-transparent opacity-50 hover:opacity-100'
                    }`}
                  >
                    <img src={img} alt={`썸네일 ${idx + 1}`} className="w-full h-full object-cover" />
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}